import * as React from 'react';

import classnames from 'classnames';

import type {HeaderGroup} from '../types';

import {TableFooterCell} from './table-footer-cell';

import styles from '../table-header/table-header-row.module.css';

type Props = {
    isResizable: boolean;
    isCompact: boolean;
    footerGroup: HeaderGroup;
    hasCellBorders: boolean;
    hasBottomBorder: boolean;
    hasLeftBorder: boolean;
    hasRightBorder: boolean;
    extendToFitWidth?: boolean;
    shouldFooterAlign?: boolean;
};

export function TableFooterRow(props: Props) {
    const {isResizable, isCompact, footerGroup} = props;

    const styleNames = classnames({
        [styles['border--bottom']]: props.hasBottomBorder,
        [styles['border--left']]: props.hasLeftBorder,
    });

    const TR = isResizable ? 'div' : 'tr';

    return (
        <TR {...footerGroup.getFooterGroupProps()} className={classnames('flex', styleNames)}>
            {footerGroup.headers.map((column, index) => {
                const getHasCellBorders = () => {
                    if (!props.hasRightBorder && index === footerGroup.headers.length - 1) {
                        return false;
                    } else {
                        return props.hasCellBorders;
                    }
                };

                return (
                    <TableFooterCell
                        column={column}
                        isResizable={isResizable}
                        isCompact={isCompact}
                        key={column.id}
                        hasCellBorders={getHasCellBorders()}
                        shouldFooterAlign={props.shouldFooterAlign}
                    >
                        <span className={styles.truncated}>{column.render('Footer')}</span>
                    </TableFooterCell>
                );
            })}
            {props.extendToFitWidth ? (
                <td className={styles['extend-to-fit-placeholder-cell']} />
            ) : null}
        </TR>
    );
}
